
import { Component, Vue } from "vue-property-decorator"
import { Getter, State } from "vuex-class"
import { CurrentUser } from "@/types/user"
import { BaseState } from "@/store"
import QuickCreate from "../Cases/EditingCase/CasePopup.vue"

// TODO remove
import VuePerfectScrollbar from "vue-perfect-scrollbar"

@Component({
	components: {
		"quick-create": QuickCreate,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class QuickCreateMenu extends Vue {
	@State((state: BaseState) => state.screenWidth)	private screenWidth!: number;
	@State((state: BaseState) => state.me) private me!: CurrentUser;

	@Getter("getCaseName") private readonly caseName!: string;
	@Getter("getRecordName") private readonly recordName!: string;

	// TODO later this should be refactored to only be template id, no point wrapping it in an object as far as I can see
	public selectedTemplate: { templateId: string | null } | null = null

	searchTerm = ""

	get filteredQuickCreateTemplates () {
		const searchTermLowerCase = this.searchTerm.toLowerCase()
		return this.quickCreateTemplates.filter(template => template.label.toLowerCase().includes(searchTermLowerCase)).sortBy("label")
	}

	private get hasQuickCreateTemplates (): boolean {
		return (this.me?.quickCreateTemplates?.length ?? 0) > 0
	}

	get quickCreateTemplates (): { id: string, label: string } [] {
		if (!this.hasQuickCreateTemplates) {
			return []
		}

		return this.me.quickCreateTemplates!
	}

	public quickCreate (templateId: string | null) {
		this.selectedTemplate = { templateId }
	}
}
